import { render } from "./ISort.vue?vue&type=template&id=70f02e6f"
import script from "./ISort.vue?vue&type=script&lang=js"
export * from "./ISort.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__